<template>
  <div>
    <div class="result-header">
      <div class="brand-slot" role="button" tabindex="0" @click="$router.push({ name: 'HomeIndex' })" @keyup.enter="$router.push({ name: 'HomeIndex' })">
        <img v-if="config && config.site_mobile_logo" :src="config.site_mobile_logo">
      </div>
      <div class="result-search-box">
        <input v-model="currentKeyword" type="text" placeholder="Search Products" @keyup.enter="submit">
        <button class="iconfont" type="button" @click="submit">&#xe689;</button>
      </div>
    </div>
    <div v-if="showTabs" class="result-tabs">
      <button type="button" :class="{ active: activeTab === 'products' }" @click="switchTab('products')">Products</button>
      <button type="button" :class="{ active: activeTab === 'suppliers' }" @click="switchTab('suppliers')">Suppliers</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SearchResultHeader',
  props: {
    keyword: {
      type: String,
      default: ''
    },
    activeTab: {
      type: String,
      default: 'products'
    },
    showTabs: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentKeyword: this.keyword
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    })
  },
  watch: {
    keyword (value) {
      this.currentKeyword = value
    }
  },
  methods: {
    submit () {
      this.$emit('search', this.currentKeyword.trim())
    },
    switchTab (tab) {
      this.$emit('switch-tab', tab, this.currentKeyword.trim())
    }
  }
}
</script>

<style scoped lang="scss">
.result-header {
  display: flex;
  align-items: center;
  height: 2.35rem;
  padding: 0 0.45rem;
  background: #fff;
  border-bottom: 1px solid #e8eaed;
  box-sizing: border-box;
}
.back-btn {
  width: 1.3rem;
  height: 1.7rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #30343a;
  font-size: 0.8rem;
  flex-shrink: 0;
}
.brand-slot {
  width: 5.2rem;
  height: 1.45rem;
  margin-right: 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
}
.brand-slot img {
  max-width: 100%;
  max-height: 100%;
}
.result-search-box {
  display: flex;
  align-items: center;
  min-width: 0;
  height: 1.65rem;
  flex: 1;
  border: 1px solid #24282d;
  border-radius: 0.85rem;
  overflow: hidden;
  background: #f6f7f8;
}
.result-search-box input {
  min-width: 0;
  flex: 1;
  height: 1.55rem;
  padding: 0 0.5rem;
  border: 0;
  outline: 0;
  background: transparent;
  color: #24282d;
  font-size: 0.68rem;
}
.result-search-box button {
  width: 2.05rem;
  height: 1.45rem;
  margin-right: 0.1rem;
  padding: 0;
  border: 0;
  border-radius: 0.75rem;
  background: #24282d;
  color: #fff;
  font-size: 0.85rem;
}
.result-tabs {
  display: flex;
  height: 2rem;
  border-bottom: 1px solid #e8eaed;
  background: #fff;
}
.result-tabs button {
  position: relative;
  flex: 1;
  border: 0;
  background: transparent;
  color: #777;
  font-size: 0.7rem;
}
.result-tabs button.active {
  color: #222;
  font-weight: 700;
}
.result-tabs button.active:after {
  content: '';
  position: absolute;
  left: 25%;
  right: 25%;
  bottom: -1px;
  height: 0.1rem;
  background: #e93b3d;
}
</style>
